import React, { useRef, useCallback } from 'react';
import './SocialMediaFeed.css';
import { Instagram, ArrowUpRight } from 'lucide-react';

const socialPosts = [
  {
    id: 1,
    image: require('../assets/socialmedia/s1.webp'),
    caption: 'Elegant bedroom suite with timeless luxury aesthetics.',
    platform: 'instagram',
    link: 'https://www.instagram.com/sakae.in/',
  },
  {
    id: 2,
    image: require('../assets/socialmedia/s2.webp'),
    caption: 'Gourmet kitchen with black marble & sleek brass finishes.',
    platform: 'instagram',
    link: 'https://www.instagram.com/sakae.in/',
  },
  {
    id: 3,
    image: require('../assets/socialmedia/s3.webp'),
    caption: 'Modern living room design crafted for cozy luxury.',
    platform: 'instagram',
    link: 'https://www.instagram.com/sakae.in/',
  },
];

const SocialCard = ({ post, index }) => {
  const ref = useRef(null);
  const onMouseMove = useCallback((e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width  - 0.5;
    const y = (e.clientY - rect.top)  / rect.height - 0.5;
    el.style.transform = `perspective(900px) rotateY(${x * 10}deg) rotateX(${-y * 8}deg) scale(1.03)`;
    el.style.boxShadow = `${-x * 16}px ${y * 16}px 45px rgba(0,0,0,0.30), 0 0 0 1px rgba(212,175,55,0.30)`;
  }, []);
  const onMouseLeave = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    el.style.transform = 'perspective(900px) rotateY(0deg) rotateX(0deg) scale(1)';
    el.style.boxShadow = '';
    el.style.transition = 'transform 0.6s ease, box-shadow 0.6s ease';
  }, []);

  return (
    <div
      ref={ref}
      className={`reveal-depth delay-${(index % 3) + 1} group relative h-80 rounded-2xl overflow-hidden cursor-pointer border border-amber-300/20 shadow-xl transition-all duration-300 will-change-transform`}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseLeave}
    >
      <a href={post.link} target="_blank" rel="noopener noreferrer" className="block w-full h-full">
        <img
          src={post.image}
          alt={post.caption}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#021a13]/90 via-[#021a13]/40 to-transparent opacity-80 group-hover:opacity-95 transition-opacity duration-300"></div>
        <div className="absolute bottom-5 left-5 right-5 text-white">
          <div className="flex items-center gap-2 text-amber-400 text-xs font-serif uppercase tracking-widest mb-1">
            <Instagram size={14} /> @sakae.in
          </div>
          <p className="text-sm font-medium leading-snug text-gray-200">{post.caption}</p>
        </div>
        <div className="absolute top-4 right-4 bg-amber-400/90 text-gray-900 p-2.5 rounded-full opacity-0 group-hover:opacity-100 transform group-hover:scale-110 transition-all duration-300 shadow-lg">
          <ArrowUpRight size={18} />
        </div>
      </a>
    </div>
  );
};

const SocialMediaFeed = () => {
  return (
    <section
      className="py-24 relative overflow-hidden text-white"
      style={{
        backgroundColor: '#021a13',
        background: 'linear-gradient(180deg, #021a13 0%, #03291d 50%, #021a13 100%)',
        color: "#ffffff"
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16 reveal-left">
          <p className="font-serif text-xs uppercase tracking-widest text-amber-400 mb-2">Connect With Us</p>
          <h2 className="text-4xl md:text-5xl font-serif font-normal text-white mb-4">
            Follow Us On Instagram
          </h2>
          <div className="w-20 h-0.5 bg-gradient-to-r from-amber-600 via-amber-400 to-amber-600 mx-auto mb-4"></div>
          <p className="text-base text-gray-300 max-w-2xl mx-auto">
            Get daily design inspiration, site progress updates, and behind-the-scenes glimpses from Sakae Studio.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {socialPosts.map((post, idx) => (
            <SocialCard key={post.id} post={post} index={idx} />
          ))}
        </div>

        <div className="text-center">
          <a
            href="https://www.instagram.com/sakae.in/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-gold"
          >
            Explore @sakae.in On Instagram <Instagram size={16} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default SocialMediaFeed;